const parseDate = (date: string, locale = "it-IT") =>
  date &&
  new Date(date).toLocaleString(locale, {
    dateStyle: "short",
    timeStyle: "short",
  });
export default parseDate;
